import Template from './popup.vue';

let globalOptions = {
    show: false,
    closable: true,
    title: {
        content: '',
        cssClass: '',
        style: {}
    },
    message: {
        content: '',
        cssClass: '',
        style: {}
    },
    buttons: [],
    closeBtn: {
        cssClass: '',
        style: {}
    },
    messageBox: {
        cssClass: '',
        style: {}
    },
    msgFooter: {
        cssClass: '',
        style: {}
    }
};

let instance;

const Popup = function(config = {}) {
    let Tpl = this.extend(Template);
    instance = new Tpl();
    config = {
        ...globalOptions,
        ...config
    };
    for(let key in config) {
        if(config.hasOwnProperty(key)) {
            instance.$data[key] = config[key];
        }
    }
    instance.$data.show = true;
    document.body.style.overflow = 'hidden';
    document.body.appendChild(instance.$mount().$el);
}

const Alert = function(message, callback){
    let alertConfig = {
        type: 'info',
        message: {
            content: message
        },
        buttons: [{
            label: 'Cerrar',
            style: {
                margin: '0',
                width: '100%',
                height: '40px',
                lineHeight: '40px',
                boxSizing: 'border-box',
                border: 'none'
            },
            action: function(){
                Dismiss();
                callback && callback();
            }
        }],
        msgFooter: {
            style: {
                padding: '0'
            }
        }
    };

    Popup.call(this, {
        ...globalOptions,
        ...alertConfig
    });
}

const Confirm = function( title, message, buttonConfirm, buttonCancel, callbackSuccess, callbackError){
    let confirmConfig = {
        type: 'info',
        title: {
            content: title
        },
        message: {
            content: message
        },
        buttons: [{
            label: buttonConfirm,
            style: {
                margin: '0',
                padding: '15px',
                width: '50%',
                height: '60px',
                boxSizing: 'border-box',
                border: 'none',
                borderRight: '1px solid #f8f8f8',
                lineHeight: '2'
            },
            action: function(){
                Dismiss();
                callbackSuccess && callbackSuccess(true);
            }
        }, {
            label: buttonCancel,
            style: {
                margin: '0',
                padding: '15px',
                width: '50%',
                height: '60px%',
                boxSizing: 'border-box',
                border: 'none',
                lineHeight: '2'
            },
            action: function(){
                Dismiss();
                callbackError && callbackError(false);
            }
        }],
        msgFooter: {
            style: {
                padding: '0'
            }
        }
    };
    
    Popup.call(this, {
        ...globalOptions,
        ...confirmConfig
    });
}

const ImageClip = function( image, callback){
    let confirmConfig = {
        type: 'image',
        message: {
            content: image
        },
        buttons: [{
            label: 'Confirmar',
            style: {
                margin: '0',
                padding: '3%',
                width: '50%',
                height: '40%',
                boxSizing: 'border-box',
                border: 'none',
                borderRight: '1px solid #f8f8f8',
                lineHeight: '2'
            },
            action: function(){
                console.log( instance.$refs );
                const canvas = instance.$refs.clipper.clip();//call component's clip method
                console.log( canvas );
                Dismiss();
                callback && callback(true);
            }
        }, {
            label: 'Cancelar',
            style: {
                margin: '0',
                padding: '3%',
                width: '50%',
                height: '40%',
                boxSizing: 'border-box',
                border: 'none',
                lineHeight: '2'
            },
            action: function(){
                Dismiss();
                callback && callback(false);
            }
        }],
        msgFooter: {
            style: {
                padding: '0'
            }
        }
    };
    
    Popup.call(this, {
        ...globalOptions,
        ...confirmConfig
    });
}

const Dismiss = () => {
    instance.$data.show = false;
    document.body.style.overflow = 'auto';
}

export default {
    install(Vue) {
        Vue.prototype.$popup = Popup.bind(Vue);
        Vue.prototype.$popup.alert = Alert.bind(Vue);
        Vue.prototype.$popup.confirm = Confirm.bind(Vue);
        Vue.prototype.$popup.image = ImageClip.bind(Vue);
    }
}